function initializeSearch() {
    const searchInput = document.getElementById("search-input");
    const searchBtn = document.getElementById("search-btn");
    const paginationContainer = document.querySelector(".pagination");
    const noResultsMessage = document.getElementById("no-results");
    const resultCount = document.querySelector(".product-facet__meta-bar-item--count");
    const productListContainer = document.querySelector(".product-list__inner");

    let allProducts = []; // Array to store all product items from all pages.

    // Function to load products from all pagination pages
    const loadAllProducts = async () => {
        const pageNumbers = Array.from(paginationContainer.querySelectorAll("a[data-page]"))
            .map(a => parseInt(a.getAttribute("data-page")))
            .filter(Boolean);

        const maxPage = pageNumbers.length > 0 ? Math.max(...pageNumbers) : 1;
        const baseUrl = window.location.href.split("?")[0];

        // Build URLs for all pages
        const paginatedUrls = [window.location.href];
        for (let i = 2; i <= maxPage; i++) {
            paginatedUrls.push(`${baseUrl}?page=${i}`);
        }

        const productPromises = paginatedUrls.map((url) =>
            fetch(url)
                .then((response) => response.text())
                .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");
                    const products = Array.from(doc.querySelectorAll(".product-item"));
                    return products.map((product) => product.outerHTML); // Save product HTML as string
                })
        );

        const productHTMLLists = await Promise.all(productPromises);
        allProducts = productHTMLLists.flat(); // Flatten the array of arrays
    };

    // Function to filter and display results
    const filterResults = () => {
        const query = searchInput.value.toLowerCase().trim();
        let visibleCount = 0;

        // Clear the product list container
        productListContainer.innerHTML = "";

        if (query === "") {
            // Show all products if no query
            allProducts.forEach((productHTML) => {
                productListContainer.insertAdjacentHTML("beforeend", productHTML);
                visibleCount++;
                // Set opacity of all products to 1
                const insertedProduct = productListContainer.lastElementChild;
                insertedProduct.style.opacity = "1";
            });

            if (paginationContainer) paginationContainer.style.display = "flex"; // Show pagination
            if (noResultsMessage) noResultsMessage.style.display = "none"; // Hide "No results found" message
        } else {
            // Filter products based on query
            allProducts.forEach((productHTML) => {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = productHTML;
                const productElement = tempDiv.firstElementChild;

                const skuElement = productElement.querySelector(".variant-sku");
                const text = skuElement ? skuElement.textContent.toLowerCase().trim() : "";
                if (text.includes(query)) {
                    productListContainer.insertAdjacentHTML("beforeend", productHTML);
                    visibleCount++;

                    // Set opacity of the search result product-item to 1
                    const insertedProduct = productListContainer.lastElementChild;
                    insertedProduct.style.opacity = "1";
                }
            });

            if (paginationContainer) paginationContainer.style.display = "none"; // Hide pagination when searching
            if (noResultsMessage) noResultsMessage.style.display = visibleCount > 0 ? "none" : "block"; // Show "No results found"
        }

        if (resultCount) {
            resultCount.textContent = visibleCount === 1 ? `${visibleCount} product` : `${visibleCount} products`;
        }
    };

    // Event listeners
    const setupEventListeners = () => {
        if (searchInput) {
            searchInput.addEventListener("input", filterResults);
        }

        if (searchBtn) {
            searchBtn.addEventListener("click", () => {
                if (searchInput && searchInput.value.trim() === "") {
                    alert("Please enter a search term.");
                }
            });
        }
    };

    // Initialize the script
    const initialize = async () => {
        if (paginationContainer) {
            await loadAllProducts(); // Load all paginated products.
        } else {
            const currentProducts = Array.from(document.querySelectorAll(".product-item"));
            allProducts = currentProducts.map((product) => product.outerHTML); // Save HTML of current products
        }

        setupEventListeners(); // Set up event listeners after loading products.
    };

    initialize();
}
initializeSearch();

// function initializeSearch(){
//     const searchInput = document.getElementById("search-input");
//     const searchBtn = document.getElementById("search-btn");
//   const p_count = document.getElementById("product___count");
//     const pagination_col = document.querySelector(".pagination");
//     const noResultsMessage = document.getElementById("no-results");
//     const resultCount = document.querySelector(".product-facet__meta-bar-item--count"); // Element to display count

//     // Function to initialize search

//         const searchItems = document.querySelectorAll(".product-list__inner .product-item");

//         const filterResults = () => {
//             const query = searchInput.value.toLowerCase().trim();
//             let visibleCount = 0;

//             // Show all items when query is empty
//             if (query === "") {
//                 searchItems.forEach((item) => {
//                     item.style.display = "list-item";
//                 });

//                 if (pagination_col) {
//                     pagination_col.style.display = searchItems.length > 0 ? "flex" : "none"; // Show pagination if there are items
//                 }

//                 visibleCount = searchItems.length;
//                 if (resultCount) {
//                     resultCount.textContent = visibleCount === 1 ? `${visibleCount} product` : `${visibleCount} products`;
//                 }

//                 if (noResultsMessage) {
//                     noResultsMessage.style.display = "none"; // Hide "No results found" message
//                 }

//                resultCount.textContent = p_count.value === 1 ? `${p_count.value} product` : `${p_count.value} products`;
              
//             } else {
//                 // Filter items based on search query
//                 searchItems.forEach((item) => {
//                     const text = item.querySelector('.variant-sku').textContent.toLowerCase();
                  
//                     if (text.includes(query)) {
//                         item.style.display = "list-item";
//                         visibleCount++;
//                     } else {
//                         item.style.display = "none";
//                     }
//                 });

//                 if (pagination_col) {
//                     pagination_col.style.display = visibleCount > 0 ? "flex" : "none";
//                 }

//                 if (noResultsMessage) {
//                     noResultsMessage.style.display = visibleCount > 0 ? "none" : "block";
//                 }

//                 if (resultCount) {
//                     resultCount.textContent = visibleCount === 1 ? `${visibleCount} product` : `${visibleCount} products`;
//                 }
//             }
//         };

//         if (searchInput) {
//             searchInput.removeEventListener("input", filterResults); // Remove any existing listener to avoid duplicates
//             searchInput.addEventListener("input", filterResults); // Attach the filter function
//         }


//     // Event listener for search button click
//     if (searchBtn) {
//         searchBtn.addEventListener("click", () => {
//             if (searchInput && searchInput.value.trim() === "") {
//                 alert("Please enter a search term.");
//             }
//         });
//     }
// };
// initializeSearch();